import axiosInstance from '../../main/axios';
import { toastr } from 'react-redux-toastr';
import { initialize } from 'redux-form';
import { showTabs, selectTab } from '../../common/tab/tabActions';

const INITIAL_VALUES = { ativo: '1' };

export { selectTab };

export function getList() {
  const request = axiosInstance.get('/manutencao/equipes');
  return {
    type: 'EQUIPE_FETCHED',
    payload: request,
  };
}

export const setPaginaAtual = pagina => ({
  type: 'EQUIPE_PAGE',
  payload: pagina,
});

function normalize(values) {
  return {
    ...values,
    ativo: parseInt(values.ativo, 10) === 1,
  };
}

export function create(values) {
  return submit(normalize(values), 'post');
}

export function update(values) {
  return submit(normalize(values), 'put');
}

export function remove(values) {
  return dispatch => {
    axiosInstance
      .delete(`/manutencao/equipes/${values.id}`)
      .then(() => {
        toastr.success('Sucesso', 'Equipe removida com sucesso.');
        dispatch(init());
      })
      .catch(e => {
        const erros = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', erros || 'Não foi possível remover a equipe.');
      });
  };
}

function submit(values, method) {
  return dispatch => {
    const id = values.id ? values.id : '';
    const url = method === 'put' ? `/manutencao/equipes/${id}` : '/manutencao/equipes';
    axiosInstance[method](url, values)
      .then(() => {
        toastr.success('Sucesso', 'Operação realizada com sucesso.');
        dispatch(init());
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível salvar a equipe.');
      });
  };
}

export function showUpdate(equipe) {
  return [
    showTabs('tabUpdate', 'tabMembros'),
    selectTab('tabUpdate'),
    initialize('equipeForm', { ...equipe, ativo: equipe.ativo ? '1' : '0' }),
    { type: 'EQUIPE_SELECTED', payload: equipe },
  ];
}

export function showMembros(equipe) {
  return [
    showTabs('tabUpdate', 'tabMembros'),
    selectTab('tabMembros'),
    initialize('equipeForm', { ...equipe, ativo: equipe.ativo ? '1' : '0' }),
    { type: 'EQUIPE_SELECTED', payload: equipe },
  ];
}

export function init() {
  return [
    showTabs('tabList', 'tabCreate'),
    selectTab('tabList'),
    getList(),
    initialize('equipeForm', INITIAL_VALUES),
  ];
}
